import axios from "axios";
import configs from "../../../../configurations/configs.json";

const IP = configs.SERVER_IP;

const state = {
  box_details: {},
  message: {},
};

const actions = {
  async calculateArrears({ commit }, data) {
    await axios
      .post(IP + "/client/physical/calculate_arrears", data)
      .then((response) => {
        commit("setArrearsResponse", response.data);
      })
      .catch((error) => {
        commit("setErrorsMessageArrears", error.response.data);
      });
  },

  async doPayArrears({ commit }, data) {
    await axios
      .post(IP + data)
      .then((response) => {
        commit("setPayArrearsResponse", response.data);
      })
      .catch((error) => {
        commit("setPayArrearsFailure", error.response.data);
      });
  },
};

const getters = {
  getBoxArrearsData: (state) => state.box_details,
  getErrorsMessageArrears: (state) => state.message,
};

const mutations = {
  setArrearsResponse: (state, response) => {
    state.box_details = response;
  },

  setErrorsMessageArrears: (state, error) => {
    state.message = error.message;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
